module.exports = __webpack_public_path__ + "static/media/luxembourg.7cc8b2fa.png";